//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { toListString } from 'src/util/helper';
import NOT_PUSHED_REASONS from 'src/resources/not_pushed_reasons.hjson';

export default {
	name: 'OverviewErrors',
	data: () => ({
		showUpdate: true,
	}),
	computed: {
		...mapState('vehicle', ['history']),
		...mapState('datasource', ['type']),
		...mapGetters('vehicle', ['failedVehicles']),
	},
	methods: {
		humanizeErrors(errors) {
			if (!errors.length) return 'Unbekannter Fehler';
			return errors
				.map(errId => NOT_PUSHED_REASONS[errId])
				.filter(Boolean)
				.join(', ') || 'Unbekannter Fehler';
		},
		async importVehicles() {
			this.showUpdate = false;
			await this.$store.dispatch('vehicle/importVehicles', this.type);
			await this.$store.dispatch('vehicle/getHistory');
			setTimeout(() => {
				this.showUpdate = true;
			}, 30000);
		},
		getEditLink(vehicle) {
			const params = params => toListString(params, '&', encodeURIComponent);
			if (vehicle.mobileId) {
				return `https://handel.mobile.de/inserat/ryiDetail.html?${params({
					flow: 'revise',
					target: 'inventory',
					id: vehicle.mobileId,
				})}`;
			}
			if (vehicle.as24Id) {
				return `https://www.autoscout24.de/listing-form#/vehicleidentification?${params({
					vGuid: vehicle.as24Id,
					lct: 'edit',
				})}`;
			}
		},
	},
};
